'use client'

import { cn } from '@/lib/utils'
import { useStoreI18n } from '@/store'
import { Typo3Header } from '@/types/typo3'
import { ButtonIcon } from '@/ui/components'
import { memo } from 'react'

const SearchInput = ({
  data,
  ref,
  variant = 'desktop',
  inputProps,
  ...props
}: {
  data: Typo3Header['search']
  ref?: React.RefObject<HTMLInputElement>
  variant?: 'mobile' | 'desktop'
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>
  props?: React.FormHTMLAttributes<HTMLInputElement>
}) => {
  const D = useStoreI18n.use.dictionary()

  return (
    <form
      className={cn(
        'flex items-center justify-between gap-x-0.5 bg-neutral-200 md:gap-x-2',
        variant === 'desktop' && 'h2',
        variant === 'mobile' && ''
      )}
      action={data?.link?.href}
      tabIndex={-1}
      aria-hidden="true"
      {...props}
    >
      <input
        id="search-input"
        name="q"
        ref={ref}
        type="search"
        aria-label="Search"
        placeholder={
          data?.placeHolder ||
          D['fe.header.search.placeholder'] ||
          data?.link?.linkText
        }
        className={cn(
          'global-focus grow',
          variant === 'desktop' &&
            'pl-xl pr-md h-full placeholder:text-neutral-300',
          variant === 'mobile' && 'pl-sm pr-none h-12 w-auto'
        )}
        {...inputProps}
      />
      <ButtonIcon
        icon="material-symbols:search"
        aria-label="Search"
        aria-labelledby="search-input"
        title="Search"
        className={cn(
          '[&>div]:size-7',
          variant === 'desktop' && 'size-16 [&>div]:size-7',
          variant === 'mobile' && 'size-12 [&>div]:size-5'
        )}
      />
    </form>
  )
}

export default memo(SearchInput)
